import styled from "styled-components";

export const JbTermsAndConditionsBox = styled.div`
    padding-top: 1rem;
    a {
        text-decoration: underline;
    }

    h2, h3 {
        color: ${props => props.theme.colors.text};
    }
`